module.exports = __webpack_public_path__ + "static/media/4.-Link-match-illustration.437f5518.svg";